import PlanDetailPage from '@/components/PlanDetailPage';

const PricingCeMembership = () => {
  return <PlanDetailPage planId="ce-membership" />;
};

export default PricingCeMembership;
